import { Component, ViewChild } from '@angular/core';
import { ShowComponent } from 'src/app/common/component/show.component';
import { ResidentTripListFilterComponent } from './resident-trip-list/resident-trip-list-filter/resident-trip-list-filter.component';

@Component({
	selector: 'app-resident-trip',
	templateUrl: './resident-trip.component.html',
	styleUrls: ['./resident-trip.component.css'],
})
export class ResidentTripComponent extends ShowComponent {
	@ViewChild(ResidentTripListFilterComponent)
	residentDestinationFilterComponent: ResidentTripListFilterComponent;
	protected itemsBeforeDataLoad = 2;
	protected parentComponent = 'resident/residentTrips';
	protected apiUrl = 'resident/residentTrips/';
	protected apiUrlAdd = '/resident/residentTrips/';
	protected peopleList: Array<any> = [];
	residentBaseTrips: Array<any> = [];
	bagStops: Array<any> = [];
	filters;
	parameters = {
		destinations: [],
	};
	filteredBagStops: Array<any> = [];
	selectedTrip = null;
	data = {
		id: null,
		residentBaseTrips: null,
		date: null,
		contigent: null,
		freePlaces: null,
		destinations: [],
		departureDetail: [],
	};

	protected loadBefore() {
		this.api.get('/bag/bagStops/', (result) => {
			this.bagStops = result.data;
			this.loadData();
		});
	}

	departuresDetail() {
		this.data.departureDetail = this.residentBaseTrips.find(
			(objfind) => objfind.id == this.data.residentBaseTrips,
		).destinations;
		this.bagStopsDestination();
	}

	protected afterLoadData() {
		const parms: string = this.api.getChecked(this.filters, this.parameters);
		this.api.get('/resident/residentBaseTrips/?' + parms, (result) => {
			this.residentBaseTrips = result.data;
		});
		this.bagStopsDestination();
	}

	calculateFreePlaces() {
		if (this.pageFunction == 'add') {
			this.data.freePlaces = this.data.contigent;
		}
	}

	save() {
		let hasError = false;
		this.data.departureDetail.forEach((obj) => {
			if (!obj.time) {
				this.infobox.error('Uzupełnij dane dotyczące godziny oraz miejsca zbiórki');
				hasError = true;
				return;
			}
		});
		if (hasError) {
			return;
		}
		this.submit();
	}

	protected bagStopsDestination() {
		this.filteredBagStops = [];
		this.data.departureDetail.forEach((obj) => {
			this.filteredBagStops = this.filteredBagStops
				.concat(this.bagStops.filter((objfind) => objfind.location == obj.bagLocations))
				.reduce(function (a, b) {
					if (a.indexOf(b) < 0) a.push(b);
					return a;
				}, []);
		});
	}

	getPeople() {
		this.api.get('/resident/reservationsPeopleList/?id=' + this.data.id + '&date=' + this.data.date, (result) => {
			this.peopleList = result.data.length;
		});
		this.checkCanceled();
	}

	protected checkCanceled() {
		this.api.get('/resident/reservationsPeopleList/?id=' + this.data.id + '&date=' + this.data.date, (result) => {
			this.peopleList = result.data;
			if (this.peopleList.length != 0) {
				this.infobox.error(
					'Przed anulowaniem terminu, należy anulować wszyskie rezerwacje dla danej wycieczki',
				);
				return;
			}
			this.deleteAsk();
		});
	}

	filtersSelected(data) {
		this.filters = data;
		this.loadData();
	}
}
